export default {
  data: function data() {
    return {
      disabled: false,
      text: this.$t('login.code')
    };
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.text = this.$t('login.code');
    },
    sendCode: function sendCode() {
      var _this = this;
      if (this.disabled) return;
      this.disabled = true;
      var n = 60;
      this.text = '剩余 ' + n + 's';
      var run = setInterval(function () {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
        }
        _this.text = '剩余 ' + n + 's';
        if (_this.text < '剩余 ' + 0 + 's') {
          _this.disabled = false;
          _this.text = '重新获取';
        }
      }, 1000);
    }
  }
};